'use strict';

const POLL_FREQUENCY = 1000 * 15, // seconds
  RestUtils = require('./../utils/RestUtils'),
  {t} = require('services/i18nextWrapper'),
  SessionStore = require('./../stores/SessionStore'),
  Security = require('./../services/Security').auth,
  get = require('lodash/object').get,
  {delay} = require('lodash/function'),
  notification = require('./../components/Notification/Notification'),
  DashboardStore = require('stores/DashboardStore'),
  DashboardAction = require('../actions/DashboardActionCreators');


/**
 * The simple polling class that ask for changes against to the server.
 * @type {{inProgress: boolean, refreshIntervalId: *, poll: Function, start: Function, stop: Function}}
 */
const PollerDashboard = {
  
  /**
   * The flag that allow as to not pull other request after finish the previous one.
   */
  inProgress: false,
  
  /**
   * The native interval id that allow as to stop the cycle when we need it.
   */
  refreshIntervalId: null,
  
  /**
   * Poll against the resources defined in dashboard to ask for dashboard changes.
   */
  poll() {
    if (this.inProgress || DashboardStore.isFetchingDashboardContent()) {
      // this will prevent, in case that fetch user dashboard content takes more than
      // poller initialization, just skip current interval poller, to finish fetching dashboard content.
      return;
    }
    const self = this;
    const ajax = RestUtils.createXHR();
    const path = process.env.URL_API + '/orders/' + SessionStore.getCurrentApplicant() + '/publish/version';
    
    try {
      
      this.inProgress = true;
      
      ajax.addEventListener('error', function (error) {
        if (!error) {
          error = {};
        }
        if (!error.type) {
          error.type = '';
        }
        
        self.inProgress = false;
      });
      
      ajax.addEventListener('load', function () {
        RestUtils.handlerResponse(this, function () {
          try {
            if (DashboardStore && DashboardStore.setIsSavedDraft) {
              DashboardStore.setIsSavedDraft();
            }
            
            if (!SessionStore.isAdminUser()) {
              if (this.responseText.indexOf('lastPublicationNumber') > -1) {
                var lastPublicationNumber = +JSON.parse(this.responseText).lastPublicationNumber;
                if ((+SessionStore.getLastPublishVersion()) < lastPublicationNumber) {
                  SessionStore.setLastPublishVersion(lastPublicationNumber);
                  notification.show(t('dashboard_notification_updated_orders'), 'info');
                  DashboardAction.publishingSuccess();
                  DashboardStore.fetchDashboardContentCurrentRange();
                }
              }
              
              if (this.responseText.indexOf('lastBrewingNoteVersion') > -1) {
                var lastBrewingVersion = +JSON.parse(this.responseText).lastBrewingNoteVersion;
                if (SessionStore.isAdminUser() === false && (+SessionStore.getLastBrewingNoteNumber()) < lastBrewingVersion) {
                  SessionStore.setLastBrewingNoteNumber(lastBrewingVersion);
                  notification.show(t('dashboard_notification_updated_notes'), 'info');
                  DashboardAction.needFetchBrewingNotes();
                }
              }
              if (this.responseText.indexOf('lastPackagingNoteVersion') > -1) {
                var lastPackagingVersion = +JSON.parse(this.responseText).lastPackagingNoteVersion;
                if (SessionStore.isAdminUser() === false && (+SessionStore.getLastPackagingNoteNumber()) < lastPackagingVersion) {
                  SessionStore.setLastPackagingNoteNumber(lastPackagingVersion);
                  notification.show(t('dashboard_notification_updated_notes'), 'info');
                  DashboardAction.needFetchPackagingNotes();
                }
              }
            }
            
            if (SessionStore.isAdminUser()) {
              const lastChangeUserToken = get(JSON.parse(this.responseText), 'lastChangeUserToken');
              const isTheSameAdminUser = Security.getToken() === lastChangeUserToken;
              
              
              // only make sense when current user is an admin
              if (!isTheSameAdminUser) {
                const lastPublicationAdminNumber = get(JSON.parse(this.responseText), 'lastPublicationAdminNumber');
                if ((+SessionStore.getLastPublicationAdminNumber()) < lastPublicationAdminNumber) {
                  SessionStore.setLastPublicationAdminNumber(lastPublicationAdminNumber);
                  notification.show(t('dashboard_notification_updateging_dashboard'), 'info');
                  delay(() => {
                    DashboardAction.updateDashboardWithUserAdmin();
                  }, 2500); // time wait until refresh browser
                }
                const lastPublicationNumber = get(JSON.parse(this.responseText), 'lastPublicationNumber');
                if ((+SessionStore.getLastPublishVersion()) < lastPublicationNumber) {
                  SessionStore.setLastPublishVersion(lastPublicationNumber);
                  notification.show(t('dashboard_notification_updateging_dashboard'), 'info');
                  delay(() => {
                    DashboardStore.fetchDashboardContentCurrentRange();
                  }, 2500); // time wait until refresh browser
                }
              }
            }
            
            self.inProgress = false;
            
          } catch (err) {
            DashboardStore.unsetIsSavedDraft();
            self.inProgress = false;
            PollerDashboard.stop();
            PollerDashboard.start(); // start over again.
          }
          
        }, function () {
          // retry again
          self.inProgress = false;
        });
      });
      
      ajax.open('GET', path);
      ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
      ajax.send();
      
    } catch (err) {
      DashboardStore.unsetIsSavedDraft();
      self.inProgress = false;
      self.stop();
      self.start(); // start over again.
    }
  },
  
  /**
   * Start pulling.
   */
  start() {
    this.refreshIntervalId = setInterval(this.poll, POLL_FREQUENCY);
  },
  
  /**
   * Stop pulling.
   */
  stop() {
    clearInterval(this.refreshIntervalId);
  }
};

module.exports = PollerDashboard;



/** WEBPACK FOOTER **
 ** ./src/pollers/PollerDashboard.js
 **/